import { Clock, UserX, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const AntiFrictionBar = () => {
  const { t } = useLanguage();

  return (
    <section className="border-y border-white/5 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-yellow-400/10 flex items-center justify-center flex-shrink-0">
              <Clock className="w-6 h-6 text-yellow-400" />
            </div>
            <div>
              <h3 className="font-bold text-white mb-1">{t("friction.noRetainers")}</h3>
              <p className="text-sm text-white/50">{t("friction.noRetainersDesc")}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-yellow-400/10 flex items-center justify-center flex-shrink-0">
              <UserX className="w-6 h-6 text-yellow-400" />
            </div>
            <div>
              <h3 className="font-bold text-white mb-1">{t("friction.noRegistration")}</h3>
              <p className="text-sm text-white/50">{t("friction.noRegistrationDesc")}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-yellow-400/10 flex items-center justify-center flex-shrink-0">
              <ShieldCheck className="w-6 h-6 text-yellow-400" />
            </div>
            <div>
              <h3 className="font-bold text-white mb-1">{t("friction.verifiedData")}</h3>
              <p className="text-sm text-white/50">{t("friction.verifiedDataDesc")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AntiFrictionBar;
